// Script module to handle variant updates and add to cart functionality

function handleAddToCart(galleryMain = null, galleryThumbs = null, galleryMobile = null) {
  let currentVariant = variantKey[Object.keys(variantKey)[0]];

  // Get current variant based on state of option selects within the form
  const getCurrentVariant = function(parentForm) {
    let currentVariantKey = "";
    parentForm.querySelectorAll('.js-product-option-select').forEach(select => {
      currentVariantKey += select.value + ":";
    });

    return variantKey[currentVariantKey];
  }

  // Update price, compare price, add to cart text, availability, sku, variant benefits, id input and current image on variant change
  const updateProductandVariantInfo = function(parentForm, variant) {
    // Update prices
    const unitPrices = parentForm.querySelectorAll('.js-product-unit-price');
    unitPrices.forEach(priceEl => {
      priceEl.textContent = variant.price;
    });

    const totalPrices = parentForm.querySelectorAll('.js-product-total-price');
    totalPrices.forEach(priceEl => {
      const qty = parentForm.querySelector('.js-product-qty-select').value;
      priceEl.textContent = "$" + variant.price_num * qty;
    });

    // Update compare price
    if (variant.compareAtPrice_num > variant.price_num) {
      parentForm.querySelectorAll('.js-product-compare-price').forEach(comparePriceEl => {
        comparePriceEl.classList.remove('hidden')
        comparePriceEl.textContent = variant.compareAtPrice;
      })
    } else {
      parentForm.querySelectorAll('.js-product-compare-price').forEach(comparePriceEl => {
        comparePriceEl.classList.add('hidden')
      });
    }

    // Update SKU 
    parentForm.querySelectorAll('.js-variant-sku').forEach(skuEl => {
      skuEl.textContent = variant.sku;
    });

    // Update add to cart submit button display based on availability
    if (variant.available) {
      parentForm.querySelector('.js-product-form-submit-text-available').classList.remove('hidden');
      parentForm.querySelector('.js-product-form-submit-text-soldout').classList.add('hidden');
    } else {
      parentForm.querySelector('.js-product-form-submit-text-available').classList.add('hidden');
      parentForm.querySelector('.js-product-form-submit-text-soldout').classList.remove('hidden');
    }

    // Update image, note that shopify indexes are base 1 so we minus 1 to work with Swiper base 0 indexing
    if (variant.image_position != null && galleryMain != null && galleryThumbs != null) {
      galleryMain.slideTo(variant.image_position - 1);
      galleryThumbs.slideTo(variant.image_position - 1);
    }

    if (variant.image_position != null && galleryMobile != null) {
      galleryMobile.slideTo(variant.image_position - 1);
    }

    // Update variant benefits - first remove all existing benefits, then add the ones from the new variant
    const productBenefits = parentForm.querySelectorAll('.js-product-benefits');
    productBenefits.forEach(benefitsEl => {
      benefitsEl.querySelectorAll('.js-variant-benefit').forEach(variantBenefitEl => {
        variantBenefitEl.remove();
      });

      variant.benefits.forEach(benefit => {
        const variantBenefitEl = document.createElement('li');
        variantBenefitEl.classList.add('js-variant-benefit');
        variantBenefitEl.textContent = benefit;
        benefitsEl.prepend(variantBenefitEl);
      });
    });

    // Update hidden id for form submission
    parentForm.querySelector('.js-product-id').value = variant.id;
  }

  // Update current variant on option select change
  const optionSelects = document.querySelectorAll('.js-product-option-select');
  optionSelects.forEach(selectEl => {
    // Set initial currentVariant
    const parentForm = selectEl.closest('form');
    currentVariant = getCurrentVariant(parentForm);

    selectEl.addEventListener('change', function(event) {
      // Get select option values of parent form & set as currentVariant
      currentVariant = getCurrentVariant(parentForm);

      // If no currentVariant, but the option has a data-product-url set, redirect to that URL
      const productUrl = event.currentTarget.querySelector('option:checked').dataset.productUrl;
      if (!currentVariant && productUrl) {
        window.location.href = productUrl;
        return;
      }

      // variantKey is a variable defined by the 'new-product--form.liquid' section
      updateProductandVariantInfo(parentForm, currentVariant);
    });
  })

  // Update total price on quantity change
  const qtySelects = document.querySelectorAll('.js-product-qty-select');
  qtySelects.forEach(qtySelect => {
    qtySelect.addEventListener('change', function(event) {
      const parentForm = event.target.closest('form');
      const qty = event.target.value;
      const totalPrices = parentForm.querySelectorAll('.js-product-total-price');
      totalPrices.forEach(priceEl => {
        priceEl.textContent = "$" + currentVariant.price_num * qty;
      });
    });
  });

  // Increment or decrement quantity on button click
  const qtyChangeButtons = document.querySelectorAll('.js-product-qty-change');
  qtyChangeButtons.forEach(qtyChangeButton => {
    qtyChangeButton.addEventListener('click', function(event) {
      const parentForm = event.target.closest('form');
      const qtySelects = parentForm.querySelectorAll('.js-product-qty-select');
      qtySelects.forEach(qtySelect => {
        const qty = parseInt(qtySelect.value);
        if (event.target.classList.contains('js-product-qty-decrement') && qty > 1) {
          qtySelect.value = qty - 1;
        } else if (event.target.classList.contains('js-product-qty-increment')) {
          qtySelect.value = qty + 1;
        }
        qtySelect.dispatchEvent(new Event('change'));
      });
    });
  });

  // Hide the element .js-sticky-add-to-cart when the element .js-static-add-to-cart is in the viewport
  const stickyAddToCart = document.querySelector('.js-sticky-add-to-cart');
  const staticAddToCart = document.querySelector('.js-static-add-to-cart');

  const options = {
    root: null,
    rootMargin: '0px',
    threshold: 0
  };

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.target === staticAddToCart) {
        if (entry.isIntersecting) {
          stickyAddToCart.style.display = 'none';
        } else {
          stickyAddToCart.style.display = 'block';
        }
      }
    });
  }, options);

  observer.observe(staticAddToCart);
}


